enum AppNavigation {
    Login = "/login",
    Register = "/register",
    SendActivationCode = "/activation-code",
    ActivateAccountViaCode = "/activate-via-code",
    Home = "/",
    Campaigns = "/campaigns",
    DraftCampaigns = "/campaigns/draft",
    ScheduledCampaigns = "/campaigns/scheduled",
    SentCampaigns = "/campaigns/sent",
    CreateCampaign = "/campaigns/create",
    EditCampaign = "/campaigns/:campaignId/edit",
    CloneCampaign = "/campaigns/:campaignId/clone",
    CampaignAddressBook = "/campaign/:campaignId/address-book",
    CampaignSendTest = "/campaign/:campaignId/send-test",
    AddressBooks = "/address-books",
    AddressBookDetail = "/address-books/:addressBookId",
    Unsubscribers = "/unsubscribers",
    ScheduleCampaing = "/campaigns/:campaignId/schedule",
    DwhRequests = "/dwh/segments",
    Reporting = "campaigns/reporting",
    StatsCampaing = "/campaigns/:campaignId/stats",
    Settings = "/settings",
    CheckNumberHLR = "/CheckNumberHLR",

    
    CampaignFilter = "/campaigns/filter/:cmAccountId",
}

export default AppNavigation;
